import {
  faCheckCircle,
  faExclamationTriangle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type ToastVariant = 'success' | 'error' | 'warning';

interface ToastProps {
  variant: ToastVariant;
  title: string;
  description?: string;
}

export const Toast = ({ variant, title, description }: ToastProps) => {
  const getIconAndColor = (toastVariant: ToastVariant) => {
    switch (toastVariant) {
      case 'success':
        return { icon: faCheckCircle, color: 'vai-text-leaf-600' };
      case 'warning':
        return { icon: faExclamationTriangle, color: 'vai-text-amber-500' };
      case 'error':
        return { icon: faTimesCircle, color: 'vai-text-red-500' };
      default:
        return { icon: faTimesCircle, color: 'vai-text-red-500' };
    }
  };

  const { icon, color: iconColor } = getIconAndColor(variant);

  return (
    <div className="vai-flex vai-flex-row vai-items-center vai-gap-3 vai-w-full">
      <FontAwesomeIcon
        icon={icon}
        style={{ width: '32px', height: '32px' }}
        className={`${iconColor} vai-rounded-full vai-p-2`}
      />
      <div className="vai-flex vai-flex-col vai-text-sm vai-gap-1 vai-flex-1">
        <span className="vai-font-semibold vai-text-gray-900">{title}</span>
        {description && (
          <span className="vai-text-gray-600">{description}</span>
        )}
      </div>
    </div>
  );
};
